import {api} from '../../App'

export const auth = (id) => {
  return api.get(`https://api.menu-rest.com/api/v1/order/${id}/kitchen`)
}
